/* globals cpac */

if (typeof cpac !== 'undefined') {
  cpac.autofilter = {
    filter: function(value, divObj, rowType) {
        if (!value) {
            return this.clear(divObj, rowType);
        }
        var chNodes = divObj.childNodes;
        if (!chNodes) {
            return;
        }
        for (var i=0; i<chNodes.length; i++) {
            if (chNodes[i].tagName == rowType) {
                var chHtml = chNodes[i].innerHTML.toLowerCase();
                if (chHtml.indexOf(value.toLowerCase()) >= 0) {
                    Element.removeClassName(chNodes[i], 'hidden');
                } else {
                    Element.addClassName(chNodes[i], 'hidden');
                }
            }
        }
  
    },
  
    clear: function(divObj, rowType) {
        var chNodes = divObj.childNodes;
        if (!chNodes) {
            return;
        }
        for (var i=0; i<chNodes.length; i++) {
            if (chNodes[i].tagName == rowType) {
                Element.removeClassName(chNodes[i], 'hidden');
            }
        }
    }
  }
}
